export const MODAL_HEIGHT = '660px';
export const MIN_MODAL_HEIGHT = '420px';
export const MODAL_WIDTH = '881px';
